import React, { useState } from 'react'
import greenTick from '../Images/GreenTick.svg'
import './Language.css'
import cholaLogo from '../Images/chola_logo.svg'
import { useDispatch, useSelector } from 'react-redux'
import { setLanguage, setShowLanguage } from './MandateSlice'

const languageDetails = [{ "name": "English", "nativeName": "English", "code": "en" }, { "name": "Tamil", "nativeName": "தமிழ்", "code": "ta" }, { "name": "Hindi", "nativeName": "हिंदी", "code": "hn" }, { "name": "Malayalam", "nativeName": "മലയാളം", "code": "ma" }, { "name": "Kanada", "nativeName": "ಕನ್ನಡ", "code": "ka" }]

function Language() {
    const { language } = useSelector((state) => state.mandateInfo);
    const selectedLang = language ? language : "English"
    const dispatch = useDispatch()
    const [lang, setLang] = useState(selectedLang)
    const valueChange = (value) => {
        setLang(value)
    }
    const langProceed = () => {
        dispatch(setLanguage(lang))
        dispatch(setShowLanguage(false))
    }
    return (
        <div class="Banner-sm">
            <div class="container Payment-way-page">
                <div class="row">
                    <div class="col-12 ps-4 pe-4">
                        <div class="Bcrumb">
                            <a href="Login.html">
                                {/* <img class="lh-1" src="assets/images/Arrow-white.svg"/> */}
                            </a>
                            <span class="Mandate-text">Language</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 p-0">
                        <div class="radio-mandate slect-radi0-filed">
                            {languageDetails.map((data) => (<div class="w-100">
                                <input type="radio" name="select" value={data?.name} checked={data?.name === lang} />
                                <label class="br-top" role="button"
                                    tabIndex={0}
                                    onClick={() => { valueChange(data?.name) }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            valueChange(data?.name)
                                        }
                                    }}>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <p>{data?.name}<span class="d-block fw-normal text-black-50">{data?.nativeName}</span>
                                        </p>
                                        <img src={greenTick} />
                                    </div>
                                </label>
                            </div>))}
                        </div>
                    </div>
                    <div class="col-12 mt-5 mb-3">
                        <button class="btn Proceed_btn w-100" type="button" onClick={langProceed}>Select</button>
                    </div>
                </div>
            </div>
        </div>
        // <div class="container">
        //     <div class="row">
        //         <div class="col-12 p-0">
        //             <div class="card p-0 ht100">
        //                 <div class="card-body p-0">
        //                     <div class="laug-header">
        //                         <img src={cholaLogo} />
        //                         <h4 class="fs-3 blue3 mt-2">Welcome to <span class="red-clr">Mandate</span></h4>
        //                         <p class="dark-gray2 mb-0">Please select the language </p>
        //                     </div>

        //                     <div class="radio-opt-pay slect-radi0-filed">
        //                         {languageDetails.map((data) => (
        //                             <div class="w-100">
        //                                 <input type="radio" name="select" 
        //                                 onChange={setLanguage(data?.name)} 
        //                                 defaultChecked={lang} value={data?.name} />
        //                                 <label class="br-top">
        //                                     <div class="d-flex justify-content-between align-items-center">
        //                                         <p>{data?.name}<span class="d-block light-grey5">{data?.nativeName}</span>
        //                                         </p>
        //                                         <img src={greenTick} />
        //                                     </div>

        //                                 </label>
        //                             </div>))}
        //                         {/* <div class="w-100">
        //                             <input type="radio" id="control_02" name="select" value="2" />
        //                             <label for="control_02">
        //                                 <div class="d-flex justify-content-between align-items-center">
        //                                     <p>Hindi<span class="d-block light-grey5">हिंदी</span>
        //                                     </p>
        //                                     <img src="../assets/img/GreenTick.svg" />
        //                                 </div>

        //                             </label>
        //                         </div>
        //                         <div class="w-100">
        //                             <input type="radio" id="control_03" name="select" value="3" />
        //                             <label for="control_03">
        //                                 <div class="d-flex justify-content-between align-items-center">
        //                                     <p>Tamil<span class="d-block light-grey5">தமிழ்</span>
        //                                     </p>
        //                                     <img src={greenTick} />
        //                                 </div>

        //                             </label>
        //                         </div>
        //                         <div class="w-100">
        //                             <input type="radio" id="control_04" name="select" value="4" />
        //                             <label for="control_04">
        //                                 <div class="d-flex justify-content-between align-items-center">
        //                                     <p>Telugu<span class="d-block light-grey5">తెలుగు</span>
        //                                     </p>
        //                                     <img src="../assets/img/GreenTick.svg" />
        //                                 </div>

        //                             </label>
        //                         </div>
        //                         <div class="w-100">
        //                             <input type="radio" id="control_05" name="select" value="5" />
        //                             <label for="control_05">
        //                                 <div class="d-flex justify-content-between align-items-center">
        //                                     <p>Malayalam<span class="d-block light-grey5">മലയാളം</span>
        //                                     </p>
        //                                     <img src="../assets/img/GreenTick.svg" />
        //                                 </div>

        //                             </label>
        //                         </div>
        //                         <div class="w-100">
        //                             <input type="radio" id="control_06" name="select" value="6" />
        //                             <label for="control_06">
        //                                 <div class="d-flex justify-content-between align-items-center">
        //                                     <p>Kannada<span class="d-block light-grey5">ಕನ್ನಡ</span>
        //                                     </p>
        //                                     <img src="../assets/img/GreenTick.svg" />
        //                                 </div>

        //                             </label>
        //                         </div>

        //                         <div class="w-100">
        //                             <input type="radio" id="control_06" name="select" value="6" />
        //                             <label for="control_06">
        //                                 <div class="d-flex justify-content-between align-items-center">
        //                                     <p>Bangla<span class="d-block light-grey5">বাংলা</span>
        //                                     </p>
        //                                     <img src="../assets/img/GreenTick.svg" />
        //                                 </div>

        //                             </label>
        //                         </div> */}
        //                         <div className="d-grid gap-2 mb-3 p-4">
        //                             <button className="btn btn-primary Proceed_btn" type="submit button">Proceed</button>
        //                         </div>
        //                     </div>








        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default Language